import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import {getListVideo} from "../../graphqlDic";
import ListVideo from './../../components/Video/List_video';
import * as TypesMedia from '../../constants/TypesMedia';
import {compose, graphql} from "react-apollo";

export default compose(
    graphql(getListVideo,{
        name:'listVideo',
        options: (props) => ({
            variables: {
                type: TypesMedia.SHOW_TV,
                channels: props.channel_id
            }
        })
    })
)(withRouter(
    connect(
        null,
        null
    )(ListVideo)
));


// WEBPACK FOOTER //
// ./src/containers/Video/Videos.js